module.exports = __webpack_public_path__ + "img/pipe.c7e1b4d8.png";